module.exports = __webpack_public_path__ + "static/WEDDING E&M-226-66e0f4e055ceab762e91048c1acfb6c7.jpg";